class ArnDragSlider {
  constructor(component) {
    console.log(component);
    window.ArnDragSlider = this;
    this.isDown = false;
    this.startX = false;
    this.scrollLeft = false;

    this.sliderEl = component;

    console.log(this.sliderEl);

    this.destroySlideHooks = this.destroySlideHooks.bind(this);
    this.createSlideHooks = this.createSlideHooks.bind(this);
    this.actionMouseDown = this.actionMouseDown.bind(this);
    this.actionMouseLeave = this.actionMouseLeave.bind(this);
    this.actionMouseUp = this.actionMouseUp.bind(this);
    this.actionMouseMove = this.actionMouseMove.bind(this);
    this.addClickListeners = this.addClickListeners.bind(this);

    this.createSlideHooks();

    if (this.sliderEl.dataset.registerClicks === `true` && this.sliderEl.dataset.flair) {
      this.addClickListeners();
    }
  }

  addClickListeners() {
    const childEls = this.sliderEl.children;
    const flair = this.sliderEl.dataset.flair;
    for (const item of childEls) {
      item.addEventListener('click', () => {
        const url = typeof item.dataset.linkUrl !== 'undefined' ? item.dataset.linkUrl : false;
        window.ArnAnalytics.customEvent({
          category: 'Button Interaction',
          action: flair,
          label: url,
        });
      });
    }
  }

  destroySlideHooks() {
    this.sliderEl.removeEventListener('mousedown', this.actionMouseDown);
    this.sliderEl.removeEventListener('mouseleave', this.actionMouseLeave);
    this.sliderEl.removeEventListener('mouseup', this.actionMouseUp);
    this.sliderEl.removeEventListener('mousedown', this.actionMouseDown);
  }

  createSlideHooks() {
    this.sliderEl.addEventListener('mousedown', this.actionMouseDown);
    this.sliderEl.addEventListener('mouseleave', this.actionMouseLeave);
    this.sliderEl.addEventListener('mouseup', this.actionMouseUp);
    this.sliderEl.addEventListener('mousemove', this.actionMouseMove);
  }

  actionMouseDown(e) {
    this.isDown = true;
    this.sliderEl.classList.add('active');
    this.startX = e.pageX - this.sliderEl.offsetLeft;
    this.scrollLeft = this.sliderEl.scrollLeft;
  }

  actionMouseLeave(e) {
    this.isDown = false;
    this.sliderEl.classList.remove('active');
  }

  actionMouseUp(e) {
    this.isDown = false;
    this.sliderEl.classList.remove('active');
  }

  actionMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.sliderEl.offsetLeft;
    const walk = (x - this.startX) * 2; // scroll-fast
    this.sliderEl.scrollLeft = this.startX - walk;
  }
}

export default component => new ArnDragSlider(component);
